<template>
  <span class="app-rotating-label__container" @click="showNext">
    <!--
    - The template is "squished" here so props can control the
    - spacing of the text with precision.
    -->
    <span v-if="staticPrefix" class="app-rotating-label__static-text">{{
      staticPrefix
    }}</span
    ><span class="app-rotating-label__dynamic-text">{{ rotatingString }}</span
    ><span v-if="staticSuffix" class="app-rotating-label__static-text">{{
      staticSuffix
    }}</span>
  </span>
</template>

<script>
export default {
  name: 'AppRotatingLabel',
  props: {
    /** A collection of strings to rotate. */
    strings: {
      type: Array,
      default: () => []
    },
    /** Controls if the rotation of strings is random or sequential. */
    random: {
      type: Boolean,
      value: true
    },
    /** A string to display before the rotating string. */
    staticPrefix: {
      type: String,
      default: undefined
    },
    /** A string to display after the rotating string. */
    staticSuffix: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      index: 0
    }
  },
  computed: {
    rotatingString () {
      const string = this.strings[this.index]
      return string
    },
    stringCount () {
      return this.strings.length
    }
  },
  mounted () {
    this.showNext()
  },
  methods: {
    showNext () {
      if (this.random) {
        const max = this.stringCount - 1
        const min = 0
        this.index = Math.floor(Math.random() * (max - min + 1)) + min
      } else {
        this.index += 1
        if (this.index >= this.stringCount) {
          this.index = 0
        }
      }
    }
  }
}
</script>

<style scoped>
.app-rotating-label__container {
  display: infline-flex;
  cursor: pointer;
  flex-shrink: 0;
  width: fit-content;
  height: 100%;
  font-family: "Avenir-Heavy", "Avenir", "Helvetica", "Sans", "sans-serif";
  letter-spacing: 0;
  text-align: center;
}

.app-rotating-label__static-text {
  color: #fff;
}

@media screen and (min-width: 960px) {
  .app-rotating-label__container {
    font-size: 1.5rem;
  }
}
@media screen and (max-width: 960px) {
  .app-rotating-label__container {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 600px) {
  .app-rotating-label__container {
    font-size: 1.5rem;
  }
}
</style>
